/**
 * SECTION - LIVE
 */

import RouteSelector from "../containers/RouteSelector";
import { views } from "./../services/constants";

const { live } = views;

const LiveRoutes = {
  routes: [
    /*{
      path: ["/living", "/viver"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "liveUA"
      }
    },
    {
      path: ["/living-ua", "/viver-ua"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "livingUA"
      }
    },
    {
      path: ["/ua-cities", "/cidades-ua"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "uaCities"
      }
    },
    {
      path: ["/transportation", "/transportes"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "transportation"
      }
    },
    {
      path: ["/public-services", "/servicos-publicos"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "publicServices"
      }
    },
    {
      path: ["/sleeping", "/alojamento"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "sleeping"
      }
    },
    {
      path: ["/eating", "/alimentacao"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "eating"
      }
    },
    {
      path: ["/sports", "/desporto"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "sports"
      }
    },
    {
      path: ["/distance-training", "/exercicio-em-casa"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "distanceTraining"
      }
    },
    {
      path: ["/health-wellness", "/saude-bem-estar"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "healthWellness"
      }
    },
    {
      path: ["/take-care-home", "/saude-em-casa"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "healthHome"
      }
    },
    {
      path: ["/culture-leisure", "/cultura-tempo-livre"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "cultureLeisure"
      }
    },
    {
      path: ["/academic-life", "/vida-academica"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "academiclife"
      }
    },
    {
      path: ["/covid-19-info", "/covid-19-info"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "covid"
      }
    },
    {
      path: ["/covid-19-faq", "/covid-19-faq"],
      component: RouteSelector,
      props: {
        activeView: live,
        document: "covidFaq"
      }
    }*/
  ]
};

export default LiveRoutes;
